import { createElementBlock as a, openBlock as o, createElementVNode as t, createVNode as m, unref as c, toDisplayString as i, normalizeClass as b, Fragment as p, renderList as v, createCommentVNode as y, withCtx as f } from "vue";
import { useTracking as w } from "../../../composables/useTracking.js";
/* empty css                                   */
import x from "../../../atoms/icon-core/icon-core.vue.js";
import C from "../../../atoms/anchor-element/anchor-element.vue.js";
const $ = ["aria-label"], B = {
  class: "ds-header-subnavigation-vertical__content",
  "data-j-links": ""
}, S = { class: "ds-text ds-padding-x-24 ds-md-padding-x-48 ds-background-color-white" }, V = {
  key: 0,
  role: "none",
  class: "ds-padding-bottom-12"
}, j = { class: "ds-heading-xsmall" }, D = { class: "ds-color-black ds-text-small" }, A = /* @__PURE__ */ Object.assign({
  name: "DsHeaderSubnavigationVertical"
}, {
  __name: "header-subnavigation-vertical",
  props: {
    /**
     * Sub navigation title
     */
    title: { type: String, required: !0 },
    /**
     * Sub navigation text
     */
    text: { type: String, required: !0 },
    /**
     * Sub navigation with background color, will add grey background color in the last item
     */
    withBackgroundColor: { type: Boolean, default: !0 },
    /**
     * Sub navigation items
     */
    items: {
      type: Array,
      required: !0,
      validator: (e) => e.every((l) => typeof l == "object" && ["title", "items"].every((u) => u in l))
    }
  },
  emits: ["link-clicked", "closed"],
  setup(e) {
    const { trackingDataProvided: l, getTrackingText: u } = w(), k = e;
    function h(s) {
      return k.items.length === 3 && s === 2 && k.withBackgroundColor;
    }
    return (s, d) => (o(), a("div", {
      class: "ds-header-subnavigation-vertical",
      "aria-label": e.title,
      role: "menu"
    }, [
      t("button", {
        type: "button",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        class: "ds-button-link ds-button-link--primary ds-button-link--black ds-header-subnavigation-vertical__button",
        "data-j-button": "",
        onClick: d[0] || (d[0] = (r) => s.$emit("closed"))
      }, [
        m(c(x), {
          category: "arrows",
          name: "chevron-left",
          class: "ds-margin-right-12"
        }),
        t("span", null, i(e.title), 1)
      ]),
      t("div", B, [
        t("div", {
          class: b([{ "ds-background-color-grey-100": e.withBackgroundColor }, "ds-header-subnavigation-vertical__content__scroll ds-scrollbar-hidden"])
        }, [
          t("p", S, i(e.text), 1),
          (o(!0), a(p, null, v(e.items.slice(0, 3), (r, g) => (o(), a("ul", {
            key: `item__${g}`,
            role: "none",
            class: b([h(g) ? "ds-background-color-grey-100" : "ds-background-color-white", "ds-header-subnavigation-vertical__group"])
          }, [
            r.title ? (o(), a("li", V, [
              t("h5", j, i(r.title), 1)
            ])) : y("", !0),
            (o(!0), a(p, null, v(r.items, (n, _) => (o(), a("li", {
              key: `sub-item__${_}`,
              class: "ds-padding-bottom-12",
              role: "none"
            }, [
              m(c(C), {
                "tracking-data": { "component-name": "DsHeaderSubnavigationVertical", text: c(u)(r, g, n), level: 2, ...c(l) },
                url: n.url,
                "open-in-new-window": n.openInNewWindow,
                nuxt: n.nuxt,
                class: "ds-button-link ds-button-link--secondary ds-button-link--green ds-header-subnavigation-vertical__link",
                role: "menuitem",
                onClick: d[1] || (d[1] = (N) => s.$emit("link-clicked"))
              }, {
                default: f(() => [
                  t("span", null, i(n.title), 1),
                  t("span", D, i(n.text), 1)
                ]),
                _: 2
              }, 1032, ["tracking-data", "url", "open-in-new-window", "nuxt"])
            ]))), 128))
          ], 2))), 128))
        ], 2)
      ])
    ], 8, $));
  }
});
export {
  A as default
};
